import React, { lazy } from "react";
import { Route } from "react-router-dom";

// Lazy load public pages
const Login = lazy(() => import("@/pages/Auth/Login/Login"));
const Register = lazy(() => import("@/pages/Auth/Register/Register"));
const ForgotPassword = lazy(() =>
  import("@/pages/Auth/ForgotPassword/ForgotPassword")
);
const SetPassword = lazy(() =>
  import("@/pages/Auth/SetupPassword/SetPassword")
);

export const AuthRoutes = (
  <>
    <Route path="/login" element={<Login />} />
    <Route path="/register" element={<Register />} />
    <Route path="/forgot-password" element={<ForgotPassword />} />
    <Route path="/setup-password" element={<SetPassword />} />
  </>
);
